<div class="align-middle wiki-link">
  <jhi-bary-icon icon="info-circle" [faDirective]="FAS" class="text-info"></jhi-bary-icon>
  <a [href]="link" target="_blank" jhiTranslate="bary-wiki-link.label"></a>
</div>
